import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject, takeUntil } from "rxjs";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { PriceyardService } from "src/app/modules/priceyard/services/priceyard.service";

@Component({
  selector: "app-edit-size-popup",
  templateUrl: "./edit-size-popup.component.html",
  styleUrls: ["./edit-size-popup.component.scss"],
})
export class EditSizePopupComponent implements OnInit,OnDestroy {
  skuList: any = [];
  account;
  otherChanges: any[] = [];
  private destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private priceyardService: PriceyardService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<EditSizePopupComponent>
  ) {}

  form: FormGroup = new FormGroup({
    regLength: new FormControl(),
    regWidth: new FormControl(),
    regHeight: new FormControl(),
    regWeight: new FormControl(),
  });
  spin: boolean;

  ngOnInit(): void {
    if (this.data) {
      this.form.controls["regLength"].setValue(this.data.RegLength);
      this.form.controls["regWidth"].setValue(this.data.RegWidth);
      this.form.controls["regHeight"].setValue(this.data.RegHeight);
      this.form.controls["regWeight"].setValue(this.data.RegWeight);
    }
  }

  close() {
    this.dialogRef.close();
  }

  action(event) {
    if (event == "Save") {
      this.editDimensions(event);
    } else {
      this.close();
    }
  }

  onChange(event, column) {
    const index=this.otherChanges.findIndex((res)=> res.name == column);
    if(index != -1){
      this.otherChanges[index].doubleValue=Number(event.target.value);
    } else{
      this.otherChanges.push({
        name: column,
        doubleValue: Number(event.target.value),
        intValue: 0,
      });
    }
  }

  editDimensions(event) {
    this.spin = true;
    this.skuList = [];
    const payload = {
      sku: this.data.Sku,
      account: this.data.Account,
      otherChanges: this.otherChanges,
      accountSkuId: this.data.AccountSkuId
    };
    this.skuList.push(payload);
    this.priceyardService.changePriceFactor(this.skuList).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.otherChanges=[];
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 9000,
          horizontalPosition: "center",
          data: {
            title: "Changes saved",
            action: "Dismiss",
            type: "success",
          },
        });
        this.spin = false;
        this.dialogRef.close(event);
      },
      error: (error) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: 'Operation Unsuccessful", please try again.',
            action: "Dismiss",
            type: "error",
          },
        });
      }
    });
  }                            

  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}